import { Component, OnInit } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Router } from "@angular/router";

@Component({
    selector: "pa-error",
    templateUrl: "./error.component.html",
    styleUrls: ["./error.component.scss"],
    standalone: false
})
export class ErrorComponent implements OnInit {
  contactUrl = environment.contactUrl;
  portalSupportEmail = environment.portalSupportEmail;

  constructor(private router: Router) {}

  ngOnInit() {}

  navToSummary() {
    localStorage.removeItem("selectedCompany");
    this.router.navigate(["landing"]);
  }
}
